var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableaublanc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tableau_blanc",
    "data-name": "tableau blanc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40,22.82l-5.24-5.24a2.13,2.13,0,0,0,.31-1.09,2.08,2.08,0,1,0-3.91,1l-5.38,5.37H13.18V49.07H52.39V22.82ZM31.7,18.1a2,2,0,0,0,2.47.1l4.63,4.62H27Zm19,29.29H14.87V24.51H50.7V47.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.82,
    y: 43.77,
    width: 6.8,
    height: 2.44
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableaublanc);
export default __webpack_public_path__ + "static/media/tableaublanc.7e1ca07b2f79d0d1efe0bd5ac94dcd2c.svg";
export { ForwardRef as ReactComponent };